import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { NFTCollection } from "../models/NFTCollection";
import { NftAssetDto, UserNftResponse } from "../models/NftAssetDto";
import { RootState } from "./store";

interface NftState{
    nfts: any[],
    nft: any,
    loading: boolean,
    error: any,
    collections: NFTCollection[],
    loadingCollections: boolean,
    message: string | null,
    importStatus: boolean,
    nftSelectionDrawerOpen: boolean,
    nftsForSelection: any[] | null,
    allMyNfts: any[] ,
    allMyOpenSeaNfts: UserNftResponse | null,
  }

const initialState: NftState = {
    nfts: [],
    nft: null,
    loading: false,
    error: null,
    collections: [],
    loadingCollections: false,
    message: null,
    importStatus: false,
    nftSelectionDrawerOpen: false,
    nftsForSelection: [],
    allMyNfts: [],
    allMyOpenSeaNfts: null,
  };


const fetchNfts = createAsyncThunk("nft/fetchNfts", async () => {
  const params = {
    MaxResultCount: 100,
  };

  const response = await axios.get("api/services/app/ExternalNFT/GetAll", {
    params,
  });

  return response?.data?.result?.items;
});

const fetchNftsForMarket = createAsyncThunk(
  "nft/fetchNftsForMarket",
  async () => {
    const params = {
      MaxResultCount: 100,
    };

    const response = await axios.get(
      "api/services/app/ExternalNFT/GetAllForMarket",
      {
        params,
      }
    );

    return response?.data?.result?.items;
  }
);

const fetchNft = createAsyncThunk("nft/fetchNft", async (id) => {
  const response = await axios.get(`api/services/app/ExternalNFT/Get?id=${id}`);
  return response?.data?.result;
}); //

export const fetchNftsForSelection = createAsyncThunk(
  "nft/fetchNftsForSelection",
  async (payload:{ id:string }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `api/services/app/UserNftCollections/GetUsersCollectionForSelection?id=${payload.id}`
      );
      return response?.data?.result;
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to fetch NFTs for selection",
        code: "FETCH_NFTS_FOR_SELECTION_FAILED",
      });
    }
  }
);

const fetchNftCollections = createAsyncThunk(
  "nft/fetchNftCollections",
    async (_, { rejectWithValue }) => {       
    
        try{
        const response = await axios.get(
        "api/services/app/UserNFTCollections/GetUsersNFTCollections",        
        );
    
        const data = response?.data?.result;
        console.log("NFT Collections",data);

        return data;

        }catch (error: any) {
        return rejectWithValue({
            message: "Failed to fetch NFT collections",
            code: "FETCH_NFT_COLLECTIONS_FAILED"
            
        });
    }
    }
);

const addNftCollection = createAsyncThunk(
  "nft/addNftCollection",
    async (payload: { collectionName?:string , collectionAddress?: string }, { rejectWithValue }) => {       
    
        try{
        const response = await axios.post(
        "api/services/app/UserNFTCollections/Create",{
            collectionName: payload.collectionName,
            collectionAddress: payload.collectionAddress
        }        
        );
    
        return response?.data?.result;

        }catch (error: any) {
        return rejectWithValue({
            message: "Failed to add NFT collection",
            code: "ADD_NFT_COLLECTIONS_FAILED"
            
        });
    }
    }
);

const fetchAllMyNfts = createAsyncThunk(
  "nft/fetchAllMyNfts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `api/services/app/ExternalNFT/GetAllMyNfts`
      );
      return response?.data?.result;
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to fetch NFTs for collection",
        code: "FETCH_NFTS_FOR_COLLECTION_FAILED",
      });
    }
  });

  const fetchAllNftsOwnedByUser = createAsyncThunk(
  "nft/fetchAllNftsOwnedByUser",
  async (_, { rejectWithValue,getState }) => {

    const userState = (getState() as RootState).user;

    const {user} = userState;

    try {
      const response = await axios.get(
        `api/services/app/ExternalNFT/GetAllNftsOwnedByUser?userAddress=${user?.walletAddress}`
      );
      return response?.data?.result;
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to fetch NFTs Owned By User",
        code: "FETCH_NFTS_OWNED_BY_USERS_FAILED",
      });
    }
  });

  const addUserNft = createAsyncThunk(
  "nft/addUserNft",
  async (payload: { nft: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "api/services/app/ExternalNFT/Create",
        {
          ...payload.nft,
        }
      );
      return response?.data?.result;
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to add NFT to collection",
        code: "ADD_NFT_TO_COLLECTION_FAILED",
      });
    }
  }
);

const removeUserNft = createAsyncThunk(
  "nft/removeUserNft",
  async (payload: { nftId: string }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `api/services/app/ExternalNFT/Delete?id=${payload.nftId}`
      );
      return payload.nftId;
    } catch (error: any) {
      return rejectWithValue({
        message: "Failed to remove NFT from collection",
        code: "REMOVE_NFT_FROM_COLLECTION_FAILED",
      });
    }
  }
);

const importNftCollection = createAsyncThunk(
  "nft/importNftCollection",
    async (payload: { nftIds:string[] , collectionId: string }, { rejectWithValue }) => {       
    
        try{
        const response = await axios.post(
        "api/services/app/UserNFTCollections/ImportCollectionNfts",{
            nftIds: payload.nftIds,
            collectionId: payload.collectionId
        }        
        );
    
        const data:{nftIds:string[],message:string,status:boolean} = response?.data?.result;

        return data;

        }catch (error: any) {
        return rejectWithValue({
            message: "Failed to IMPORT NFT collection",
            code: "IMPORT_NFT_COLLECTIONS_FAILED"
            
        });
    }
    }
);

const updateNFTCollection = createAsyncThunk(
  "nft/updateNFTCollection",
    async (payload: { id:string , collectionName: string,collectionAddress:string }, { rejectWithValue }) => {       
    
        try{
        const response = await axios.put(
        "api/services/app/UserNFTCollections/Update",{
            id: payload.id,
            collectionName: payload.collectionName,
            collectionAddress: payload.collectionAddress
        }        
        );
    
        const data:{id:string,collectionName:string,collectionAddress:string,imported: number} = response?.data?.result;
        return data;

        }catch (error: any) {
        return rejectWithValue({
            message: "Failed to update NFT collection",
            code: "UPDATE_NFT_COLLECTIONS_FAILED"
            
        });
    }
    });
const deleteNFTCollection = createAsyncThunk(
  "nft/deleteNFTCollection",
    async (payload: { id:string }, { rejectWithValue }) => {       
    
        try{
        const response = await axios.delete(
        `api/services/app/UserNFTCollections/Delete?id=${payload.id}`        
        );
    
       
        return payload.id;

        }catch (error: any) {
        return rejectWithValue({
            message: "Failed to delete NFT collection",
            code: "DELETE_NFT_COLLECTIONS_FAILED"
            
        });
    }
    });

const nftSlice = createSlice({
  name: "nft",
  initialState,
  reducers: {
    addNewRow(state, action:PayloadAction<NFTCollection>) {
      state.collections.push(action.payload);
    },
    openNftSelectionDrawer(state) {
      state.nftSelectionDrawerOpen = true;
    },
    closeNftSelectionDrawer(state) {
      state.nftSelectionDrawerOpen = false;
    },
    // setActiveTab(state, action) {
    //   state.activeTab = action.payload;
    // },
    // removeAllocationNft(state, action) {
    //   state.allocationNfts = state.allocationNfts.filter(
    //     (allocation) => allocation.id != action.payload.id
    //   );
    // },
    // addAllocationNft(state, action) {
    //   state.allocationNfts = [...state.allocationNfts, action.payload];
    // },
    // clearAllocationNft(state) {
    //   state.allocationNfts = [];
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNfts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNfts.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.nfts = action.payload;
      })
      .addCase(fetchNfts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }) 
      .addCase(fetchNft.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNft.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.nft = action.payload;
      })
      .addCase(fetchNft.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }) 
      .addCase(fetchNftsForMarket.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNftsForMarket.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.nfts = action.payload;
      })
      .addCase(fetchNftsForMarket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }).addCase(
        fetchNftCollections.pending,
        (state) => {
          state.loadingCollections = true;
          state.error = null;
        }
      ).addCase(
        fetchNftCollections.fulfilled,
        (state, action) => {
          state.loadingCollections = false;
          state.error = null;
          state.collections = action.payload;
        }
      ).addCase(
        fetchNftCollections.rejected,
        (state, action) => {
          state.loadingCollections = false;
          state.error = action.error.message;
        }
      ).addCase(
        addNftCollection.pending,
        (state) => {
          state.loadingCollections = true;
          state.error = null;
        }).addCase(
        addNftCollection.fulfilled,
        (state, action) => {
          state.loadingCollections = false;
          state.error = null;
          
           const index = state.collections.findIndex((collection) => collection.id === '0');
            if (index !== -1) {
                state.collections[index] = action.payload;
            }
          
        }).addCase(
        addNftCollection.rejected,  
        (state, action) => {
          state.loadingCollections = false;
          state.error = action.error.message;
        }).addCase(
        importNftCollection.pending,
        (state) => {
          state.loadingCollections = true;
          state.error = null;
            state.importStatus = false;
        }).addCase( 
        importNftCollection.fulfilled,
        (state, action) => {
            state.loadingCollections = false;
            state.error = null;
            state.message = action.payload.message;
            state.importStatus = action.payload.status;
            }).addCase(
        importNftCollection.rejected,
        (state, action) => {
          state.loadingCollections = false;
          state.error = action.error.message;
            state.importStatus = false;
        })
      .addCase(
        updateNFTCollection.pending,
        (state) => {
          state.loadingCollections = true;
          state.error = null;
        }).addCase( 
        updateNFTCollection.fulfilled,
        (state, action) => {
            state.loadingCollections = false;
            state.error = null;
            const index = state.collections.findIndex((collection) => collection.id === action.payload.id);
            if (index !== -1) {
                state.collections[index] = action.payload;
            }
        }).addCase( 
        updateNFTCollection.rejected,
        (state, action) => {    
            state.loadingCollections = false;
            state.error = action.error.message;
        }
        )
.addCase(
        deleteNFTCollection.pending,
        (state) => {
          state.loadingCollections = true;
          state.error = null;
        }).addCase(
        deleteNFTCollection.fulfilled,
        (state, action) => {
            state.loadingCollections = false;
            state.error = null;
            console.log("Delete NFT Collection",action.payload);
            const index = state.collections.findIndex((collection) => collection.id === action.payload);
            if (index !== -1) {
                state.collections.splice(index, 1);
            }
        }).addCase(
        deleteNFTCollection.rejected,
        (state, action) => {    
            state.loadingCollections = false;
            state.error = action.error.message;
        })
        .addCase(fetchNftsForSelection.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchNftsForSelection.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.nftsForSelection = action.payload;
        })
        .addCase(fetchNftsForSelection.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        }).addCase(fetchAllMyNfts.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchAllMyNfts.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.allMyNfts = action.payload;
        })
        .addCase(fetchAllMyNfts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        }).addCase(addUserNft.pending, (state) => {
            state.loading = true; 
            state.error = null;
        })
        .addCase(addUserNft.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.allMyNfts.push(action.payload);
        })
        .addCase(addUserNft.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        }).addCase(removeUserNft.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(removeUserNft.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.allMyNfts = state.allMyNfts.filter(nft => nft.id !== action.payload);
        })
        .addCase(removeUserNft.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
        .addCase(fetchAllNftsOwnedByUser.pending, (state) => {
            state.loading = true; 
            state.error = null;
        })
        .addCase(fetchAllNftsOwnedByUser.fulfilled, (state, action) => {
              state.loading = false;
              state.error = null;
              state.allMyOpenSeaNfts = action.payload;
          })
        .addCase(fetchAllNftsOwnedByUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

  },
});

export {
  fetchNfts,
  fetchNft,
  fetchNftsForMarket,
  deleteNFTCollection,
  updateNFTCollection,
    fetchNftCollections,
    importNftCollection,
    addNftCollection,
    fetchAllMyNfts,
    addUserNft,
    removeUserNft,
    fetchAllNftsOwnedByUser
};
export const {
// //   setAdminView,
// //   removeAllocationNft,
// //   addAllocationNft,
// //   clearAllocationNft,
  addNewRow,
  openNftSelectionDrawer,
  closeNftSelectionDrawer,
} = nftSlice.actions;
export default nftSlice.reducer;
